import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

import { Switch } from '../Switch/Switch';

interface Props {
  has_store_zigzin_option: boolean;
  checked: boolean;
  onClick: () => void;
}

export const DeliveryTypeToggle: React.FC<React.PropsWithChildren<Props>> = ({ has_store_zigzin_option, checked, onClick }) => {
  return (
    <Wrap>
      <ToggleArea has_store_zigzin_option={has_store_zigzin_option} onClick={onClick}>
        <Switch checked={checked} />
        <span className={Typography.BODY_14_SEMIBOLD}>
          {has_store_zigzin_option ? '스토어직진만 보기' : '직진배송만 보기'}
        </span>
      </ToggleArea>
    </Wrap>
  );
};

const Wrap = styled.div`
  margin: 8px 0 2px 0;
  position: relative;
  top: 11px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
`;

const ToggleArea = styled.div<{ has_store_zigzin_option: boolean }>`
  padding: 0 8px 0 0;
  display: flex;
  align-items: center;
  justify-content: end;
  color: ${({ has_store_zigzin_option }) => (has_store_zigzin_option ? vars.color.blue400 : vars.color.purple400)};

  span {
    margin: 0 0 0 6px;
  }
`;
